import React from 'react'

const Spinner = ({ className }) => {
  return (
    <div className={`${className} relative w-8 h-8`}>
      <svg viewBox="0 0 50 50" className={`spinner-bg block absolute inset-0`}>
        <circle
          className="path"
          cx="25"
          cy="25"
          r="20"
          fill="none"
          strokeWidth="5"
        ></circle>
      </svg>{' '}
      <svg viewBox="0 0 50 50" className={`spinner block absolute inset-0`}>
        <circle
          className="path"
          cx="25"
          cy="25"
          r="20"
          fill="none"
          strokeWidth="5"
        ></circle>
      </svg>
    </div>
  )
}

export default Spinner
